import { WishlistService } from '@/services'

export const getUserSuggestion = async (searchText) => {
  try {
    const response = await WishlistService.getSearchSuggestions(searchText)
    return response.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export const renameWishlist = async (requestBody) => {
  try {
    const response = await WishlistService.renameWishlist(requestBody)
    return response.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export const shareWishlistToUsers = async (requestBody) => {
  try {
    const response = await WishlistService.shareWishlistToUsers(requestBody)
    return response?.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export const shareWishlistToCompany = async (wishlistId) => {
  try {
    const response = await WishlistService.shareWishlistToCompany(wishlistId)
    return response?.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export const withdrawSharingWishlistToCompany = async (wishlistId) => {
  try {
    const response = await WishlistService.withdrawSharingWishlistToCompany(wishlistId)
    return response?.data
  } catch (error) {
    return Promise.reject(error)
  }
}
